<script lang="ts">
	import { _ } from 'utils/i18/i18n';
	import EmptyTable from 'components/EmptyTable/EmptyTable.svelte';
	import SortingArrow from 'components/SortingArrow/SortingArrow.svelte';
	import FinancialReservesTableRow from './FinancialReservesTableRow/FinancialReservesTableRow.svelte';
	import CustomButton from 'components/CustomButton/CustomButton.svelte';
	import type { IExchangeReserves } from 'src/types/exchange';
	import { getReservesData } from 'services/exchanges/reserves';

	export let dark = false;
	export let tableData: IExchangeReserves[];
	export let id;
	let sortBy: string;
	let isPressed = false;
	let page = 1;
	const pageSize = 5;
	let paginatedData: IExchangeReserves[] = tableData.slice(0, pageSize);

	function handleFilterClick(
		e: Event & { currentTarget: HTMLElement },
		direction: 'asc' | 'desc',
		property: string,
	) {
		sortBy = e.currentTarget.id;
		tableData = tableData.sort(function (a, b) {
			return direction === 'desc'
				? a.currency[property].localeCompare(b.currency[property])
				: b.currency[property].localeCompare(a.currency[property]);
		});
	}

	async function showMore() {
		page += 1;
		const raw = await getReservesData(id, page);
		const reserves: IExchangeReserves[] = Object.values(raw);
		tableData.push(...reserves);
		paginatedData = tableData.slice(0, page * pageSize);
	}
	function colapse() {
		paginatedData = tableData.slice(0, pageSize);
		page = 1;
	}
</script>

<div class="wrapper">
	<table class="table" class:dark>
		<thead class="table-head no-select">
			<tr class="table-row">
				<th
					id="token"
					class="head-cell token clickable"
					on:click={(e) => {
						if (sortBy !== 'token') isPressed = true;
						handleFilterClick(e, isPressed ? 'asc' : 'desc', 'symbol');
						isPressed = !isPressed;
					}}
				>
					{$_('exchange.token')}
					<SortingArrow {isPressed} pressedIconId={sortBy} idToCompare={'token'} width={11} height={7} />
				</th>
				<th id="balance" class="head-cell balance">{$_('exchange.balance')} </th>
				<th id="price" class="head-cell price">{$_('exchange.price')} </th>
				<th id="value" class="head-cell value">{$_('exchange.value')} </th>
			</tr>
		</thead>

		{#key tableData}
			<tbody class="table-body">
				{#if !tableData || tableData?.length === 0}
					<EmptyTable
						{dark}
						colAmountFromTabletView={4}
						colAmountMobView={4}
						tableType="financial-reserves"
						withNoDataText={tableData?.length === 0}
					/>
				{:else}
					{#each paginatedData as asset}
						<FinancialReservesTableRow data={asset} {dark} />
					{/each}
				{/if}
			</tbody>
		{/key}
	</table>
	{#if tableData.length > 0}
		<div class="btn-wrapper">
			<div class="extra-wrapper">
				<CustomButton component="btn" onClick={showMore} title="Load more tokens" linkTo={null} />
			</div>

			{#if page >= 2}
				<CustomButton component="btn" onClick={colapse} title="Colapse" linkTo={null} />
			{/if}
		</div>
	{/if}
</div>

<style lang="scss">
	@import 'financialReservesTable';
</style>
